<template>
  <div class="zyk-header">
    <div class="zyk-header-left">
      <div class="logo">
        <img src="@/assets/images/ui/zyk-logo.png" alt="" />
      </div>
      <div class="page-info">
        <div class="page-title">
          <span>资源库</span>
          <SwitchCourses
            :typeId="4"
            ref="switchCourse"
            @checkCourse="changeCheckCourse"
            @changeAddCourseDialogVisible="changeAddCourseDialogVisible"
          />
        </div>

        <div class="tabs-header">
          <div class="tabs-list clearfix">
            <div
              class="tab-item"
              :class="{
                active:
                  $route.path.indexOf(item.pagePath) > -1 &&
                  item.pageId == currentGloablPageId,
              }"
              v-for="(item, index) in globalPages"
              data-io-click="tracker"  @click="handleCheckPageTab(item, index)"
              :key="item.pageId"
            >
              {{ item.pageTitle }}
              <span class="new-tip" v-if="item.pageTitle == '名校'">new</span>
              <span class="new-tip" v-if="item.pageTitle == '绝密'">hot</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="zyk-header-right">
      <!--      教材百科按钮，目前只在 高中地理展示-->
      <div
        v-if="currentCourse && currentCourse.courseId == 34"
        data-io-click="tracker"  @click="openTextbookEncyclopediaDialog()"
        class="textbook-encyclopedia"
      >
        <svg
          v-if="showCircle"
          style="position: absolute; top: 5px; right: 3px"
          xmlns="http://www.w3.org/2000/svg"
          width="6"
          height="6"
          viewBox="0 0 6 6"
          fill="none"
        >
          <circle cx="3" cy="3" r="3" fill="#FF0000" />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <rect
            x="2.5"
            y="1"
            width="15"
            height="17"
            rx="2.33333"
            stroke="#0080FF"
            stroke-width="2"
          />
          <path
            d="M2.5 15.5C2.5 14.1193 3.61929 13 5 13H17.5V15.931C17.5 17.0737 16.5737 18 15.431 18H5C3.61929 18 2.5 16.8807 2.5 15.5Z"
            fill="#C7E0FB"
            stroke="#0080FF"
            stroke-width="2"
          />
          <path
            d="M5.3335 15.7367C5.3335 15.5066 5.52004 15.3201 5.75016 15.3201H9.0835C9.31361 15.3201 9.50016 15.5066 9.50016 15.7367V19.5842C9.50016 19.908 9.14684 20.1081 8.86912 19.9414L7.41683 19.0701L5.96454 19.9414C5.68682 20.1081 5.3335 19.908 5.3335 19.5842V15.7367Z"
            fill="#0080FF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.3481 10.0265C11.5624 11.258 9.09762 11.0794 7.50893 9.49074C5.71903 7.70084 5.71903 4.79883 7.50893 3.00893C9.29883 1.21903 12.2008 1.21903 13.9907 3.00893C15.5794 4.59759 15.758 7.06233 14.5266 8.84799L16.6424 10.9638C16.9678 11.2892 16.9678 11.8169 16.6424 12.1423C16.317 12.4677 15.7893 12.4677 15.4639 12.1423L13.3481 10.0265ZM8.68744 8.31223C7.54841 7.1732 7.54841 5.32647 8.68744 4.18744C9.82647 3.04841 11.6732 3.04841 12.8122 4.18744C13.9494 5.32462 13.9513 7.16719 12.8178 8.30666C12.8159 8.30848 12.8141 8.31031 12.8122 8.31215C12.8104 8.314 12.8086 8.31585 12.8067 8.31771C11.6673 9.45126 9.82464 9.44943 8.68744 8.31223Z"
            fill="#C7E0FB"
          />
        </svg>
        <span class="textbook-encyclopedia-word">教材百科</span>
      </div>

      <div class="search-input" v-placeholder>
        <i class="iconfont icon-sousuon" data-io-click="tracker"  @click="search"></i>
        <input
          class="search-text"
          type="text"
          placeholder="输入搜索关键词"
          v-model="keywords"
          @keyup.enter="search"
        />
      </div>
      <div class="download-btn" data-io-click="tracker"  @click="jumpMyDownload">
        <i class="iconfont icon-download1"></i>
        我的下载
      </div>
      <div class="line" v-if="syncUrl"></div>
      <div class="open-tech-btn" v-if="syncUrl" data-io-click="tracker"  @click="jumpSyncPage">
        上好课 <img src="@/assets/images/arrow-right.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import util from "@/assets/js/common/util";
import getUserTextbooks from "@/assets/js/mixin/getUserTextbook";
import api from "@/assets/js/service/api";
import SwitchCourses from "@/components/SwitchCourses.vue";
import {
  getTextbookDetail,
  getTextbooks,
  getVersions,
  getZykGlobalPages,
} from "@/utils/apis";
import request from "@/utils/request";
import { mapMutations, mapState } from "vuex";
export default {
  inject: ["textbook"],
  mixins: [getUserTextbooks],
  components: {
    SwitchCourses,
  },
  props: {
    syncUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // currentTextbook: null,
      currentVersion: null,
      // globalPages: [],
      keywords: "",
      isCheckCourse: false,
      showCircle: true,
      pageIndex: 1,
      pageSize: 30,
    };
  },
  watch: {
    // 监听课程id发生变化
    "textbook.textbooks": {
      async handler(val, oldVal) {
        // console.log("监听当前课程下面的教材列表", val, oldVal);
        // console.log()
        let { courseId, stageId, subjectId, textbookId, from } =
          this.$route.query;
        // console.log("----val,oldVal---", val, oldVal, textbookId);
        // console.log("currentCourse", this.currentCourse);
        // console.log("currentCourse", this.currentCourse);
        // console.log("----val,oldVal---", val, oldVal, textbookId);
        let textBookInfo = null;
        let currentVersion = null;
        let currentTextbook = null;
        if (this.currentCourse) {
          let {
            stageId: currentStageId,
            courseId: currentCourseId,
            subjectId: currentSubjectId,
          } = this.currentCourse;
          if (from == "xkw") {
            // console.log("来自主站", this.currentCourse,stageId,subjectId,textbookId);
            if (
              (stageId != currentStageId || subjectId != currentSubjectId) &&
              !this.isCheckCourse
            ) {
              // console.log("更新当前课程");
              if (!stageId || !subjectId) {
                let query = JSON.parse(JSON.stringify(this.$route.query));
                query.stageId = currentStageId;
                query.subjectId = currentSubjectId;
                this.$router.push({
                  path: this.$route.path,
                  query,
                });
              } else {
                // return;
                // 修改当前课程
                return;
              }
              // return;
            }
          }
          // console.log("继续调用-----", textbookId);
          // val &&
          //   val.length > 0 &&
          if (
            textbookId &&
            (courseId == this.currentCourse.courseId ||
              (stageId == this.currentCourse.stageId &&
                subjectId == this.currentCourse.subjectId))
          ) {
            textBookInfo = await this.getTextbookDetail(textbookId);
          }
          // console.log("textBookInfo----", textBookInfo);
          // 版本列表
          let { result: versionResult } = await getVersions({
            stageId: this.currentCourse.stageId,
            subjectId: this.currentCourse.subjectId,
            withUnlimited: true,
          });
          // 判断当前教材详情的版本是否在当前课程的版本列表中
          if (textBookInfo) {
            currentVersion = versionResult.find((version) => {
              return version.id === textBookInfo.versionId;
            });
          } else {
            let currentTextbook = val && val.length ? val[0] : null;
            if (currentTextbook) {
              // textBookInfo = currentTextbook
              currentVersion = versionResult.find(
                (version) => version.id == currentTextbook.versionId
              );
            } else {
              currentVersion = versionResult[0];
            }
          }
          // console.log("currentVersion", currentVersion);
          // console.log("currentVersion", currentVersion);
          let { result: textbookResult } = await getTextbooks({
            versionId: currentVersion.id,
          });
          if (textBookInfo) {
            currentTextbook = textbookResult.find((textbook) => {
              return textBookInfo.bookId == textbook.id;
            });
          } else {
            currentTextbook =
              val && val.length > 0 ? val[0] : textbookResult[0];
          }
          let query = {
            stageId: this.currentCourse.stageId,
            subjectId: this.currentCourse.subjectId,
            courseId: this.currentCourse.courseId,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            // ...this.$route.query,
            // ...this.$route.query,
            // pageId: 1,
          };
          if (this.$route?.query?.xep_flag && this.$route?.query?.title) {
            query.title = this.$route.query.title;
            this.keywords = this.$route.query.title;
          }
          // console.log("---query", this.$route.query);
          currentTextbook.versionName != "不限"
            ? (query.textbookId = currentTextbook.bookId || currentTextbook.id)
            : delete this.$route.query.textbookId;
          // console.log(
          //   "versionResult",
          //   versionResult,
          //   textbookResult,
          //   currentTextbook
          // );
          this.changeTextBookList(textbookResult);
          this.changeVersionList(versionResult);
          this.changeCurrentTextBook(currentTextbook);
          // (!from || from != "xkw")
          // console.log('====currentCourse',this.currentCourse,stageId,subjectId,this.$route.query,oldVal)
          if (
            oldVal &&
            courseId != this.currentCourse.courseId &&
            (stageId != this.currentCourse.stageId ||
              subjectId != this.currentCourse.subjectId) &&
            oldVal != val
          ) {
            let path = "";
            let params =
              from && from == "xkw"
                ? JSON.parse(JSON.stringify(this.$route.query))
                : query;
            // console.log(
            //   "切换课程",
            //   oldVal,
            //   this.$route.path.indexOf("/welcome")
            // );
            // console.log("切换课程");
            // 如果来自主站 或者 没有课程id 或者 没有阶段id 或者 没有科目id 则跳转到当前路径
            if (
              (((from && from == "xkw") ||
                (!courseId && !stageId && !subjectId)) &&
                this.$route.path.indexOf("/welcome") == -1) ||
              ((!oldVal || !oldVal.length) &&
                this.$route.path.indexOf("/welcome") > -1)
            ) {
              path = this.$route.path;
            } else {
              // console.log("切换课程");
              // 如果来自主站 则跳转到教材列表
              path = "/zyk/books";
              this.changeCurrentGloablPageId(1);
              delete params.parentAreaId;
              delete params.schoolId;
            }
            // let path = from && from == "xkw" ? this.$route.path : "/zyk/books";
            // console.log("params---", params, path);
            // console.log("currentCourse", this.currentCourse);
            params.softType = this.$route.query.softType || 1;
            this.$route.path.indexOf("/mingxiao") > -1 &&
            this.$route.query.schoolId
              ? (params.schoolId = this.$route.query.schoolId)
              : null;
            params.pageId =
              this.currentGloablPageId == 1 ? 1 : this.currentGloablPageId;
            if (
              from &&
              from == "xkw" &&
              (stageId != this.currentCourse.stageId ||
                subjectId != this.currentCourse.stageId)
            ) {
              // console.log('切换课程',this.currentCourse,stageId,subjectId)
              params.stageId = this.currentCourse.stageId;
              params.subjectId = this.currentCourse.subjectId;
              params.courseId = this.currentCourse.courseId;
              currentTextbook.versionName != "不限"
                ? (params.textbookId =
                    currentTextbook.bookId || currentTextbook.id)
                : delete params.textbookId;
            }
            // console.log(
            //   "切换课程",
            //   oldVal,
            //   this.$route.path.indexOf("/welcome"),
            //   query
            // );
            path.indexOf("/zyk/books") > -1 ? (params.pageId = 1) : null;
            if (
              !(!oldVal || !oldVal.length) ||
              this.$route.path.indexOf("/welcome") === -1
            ) {
              this.$router.push({
                path,
                query: params,
              });
            }
            // console.log("----path", path, params);
            this.isCheckCourse = false;
          }
        }
      },
      immediate: true,
      deep: true,
    },
    currentTextbook: {
      handler(val, oldVal) {
        if (val) {
          // console.log("组件val--", val, oldVal);
          this.getZykGlobalPages();
        }
      },
      immediate: true,
      deep: true,
    },
    currentCourse: {
      handler(newVal, oldVal) {
        // console.log('val,oldVal',newVal,oldVal)
        let { stageId, subjectId } = this.$route.query;
        // console.log('当前课程',newVal,oldVal)
        if (newVal && !oldVal) {
          // 跳转到同步页面
          // this.$router.push(`/zyk/books`)
        }
      },
      deep: true,
      immediate: true,
    },
    showUserCourse: {
      async handler(val) {
        // console.log("监听当前显示的课程", val, this.currentCourse);
        let { stageId, subjectId, from, documentId } = this.$route.query;
        if (this.currentCourse && val && val.length) {
          let { stageId: currentStageId, subjectId: currentSubjectId } =
            this.currentCourse;
          if (from == "xkw") {
            const data = await request.get(
              api.document.getDocDetailOpenMethod,
              { isFromXkw: true }
            );
            if (data.result == 1) {
              window.location.href = `/soft/${documentId.split("-")[0]}-${
                documentId.split("-")[1]
              }.html`;
            } else {
              if (stageId != currentStageId || subjectId != currentSubjectId) {
                console.log("不等于");
                if (!stageId || !subjectId) {
                  this.$route.query.stageId = currentStageId;
                  this.$route.query.subjectId = currentSubjectId;
                  // stageId = currentStageId;
                  // subjectId = currentSubjectId;
                }
                this.handleInitUrl();
              }
              this.$emit(
                "childDialogStatus",
                { documentId: documentId.split("-")[0] },
                documentId.split("-")[1]
              );
            }
          }
        }
      },
      immediate: true,
    },
    $route: {
      handler(to, from) {
        console.log("监听路由", to, from);
        let { title } = to.query;
        if (title) {
          this.keywords = title;
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      currentCourse: "currentCourse",
      currentTextbook: "currentTextbook",
      globalPages: "globalPages",
      currentGlobalPageId: "currentGlobalPageId",
      currentGloablPageId: "currentGloablPageId",
      showUserCourse: "showUserCourse",
    }),
  },
  methods: {
    ...mapMutations([
      "changeTextBookList",
      "changeVersionList",
      "changeCurrentTextBook",
      "changeGlobalPages",
      "changeCurrentGloablPageId",
    ]),
    changeCheckCourse() {
      // console.log('切换课程----')
      this.isCheckCourse = true;
    },
    // 搜索功能
    search() {
      this.$emit("search", this.keywords);
    },
    jumpMyDownload() {
      window.open(
        `/user/download${
          this.$route.query.xep_flag === "1" ? "?xep_flag=1" : ""
        }`
      );
    },
    // 初始化路由地址
    async handleInitUrl() {
      // 设置当前课程
      let { courseId, stageId, subjectId } = this.$route.query;
      // console.log("----stageId, subjectId", stageId, subjectId);
      // console.log("showUserCourse", this.showUserCourse);
      // 先判断是否在显示的课程里面 如果有的话直接切换课程
      let currentCourseIndex = this.showUserCourse.findIndex(
        (course) => course.stageId == stageId && course.subjectId == subjectId
      );
      // console.log(
      //   "currentCourseIndex",
      //   currentCourseIndex,
      //   this.textbook.stageListAndSubjects
      //   // this.$refs.switchCourse.handleChooseCourse
      // );
      if (currentCourseIndex > -1) {
        // console.log("课程存在直接选中课程");
        await this.$refs.switchCourse.handleChooseCourse(
          this.showUserCourse[currentCourseIndex],
          currentCourseIndex,
          1
        );
        this.textbook.getUserCourses();
        this.loadTextbooks();
        // 修改当前课程下面的教材列表
      } else {
        // console.log("课程不存在需要添加课程");
        // 添加课程 先判断这个课程是否在权限内 如果在权限内直接添加课程
        this.textbook.handleAddNewCourse(null, stageId, subjectId);
      }
    },
    async getZykGlobalPages() {
      let { pageId } = this.$route.query;
      // console.log("pageId", pageId, this.currentCourse, this.currentTextbook);
      let { result } = await getZykGlobalPages({
        courseId: this.currentCourse.courseId,
        textBookId: this.currentTextbook.bookId || this.currentTextbook.id,
      });
      // console.log("pageId---", pageId);
      let currentPage = result.find((item) =>
        pageId
          ? item.pageId == pageId
          : this.$route.path.indexOf(item.pagePath) > -1
      );
      // console.log("currentPage====", currentPage);
      if (currentPage) {
        this.changeCurrentGloablPageId(currentPage.pageId);
      }
      this.changeGlobalPages(result || []);
      // this.globalPages = result || [];
      // console.log('data',data)
    },
    jumpSyncPage() {
      if (this.syncUrl) {
        window.location.href = util.xepHref(this.syncUrl);
        // this.$router.push(this.)
      }
    },
    changeAddCourseDialogVisible(e) {
      this.textbook.changeAddCourseDialogVisible(e);
    },
    // 获取教材详情
    async getTextbookDetail(textbookId) {
      const data = await getTextbookDetail({ textbookId });
      if (data.code === 200) {
        return data.result;
      }
      return null;
    },
    handleCheckPageTab(item, index) {
      // console.log("item", item, index);
      if (
        this.$route.path.indexOf(item.pagePath) == -1 ||
        this.currentGloablPageId != item.pageId
      ) {
        this.changeCurrentGloablPageId(item.pageId);
        this.addParams(item.pagePath);
        // this.$router.push(`/zyk${item.pagePath}`);
      }
    },
    addParams(pagePath) {
      if (this.currentCourse) {
        let { courseId, subjectId, stageId } = this.currentCourse;
        let { id, bookId } = this.currentTextbook;
        let query = {
          courseId,
          subjectId,
          stageId,
          pageSize: util.pageSize,
          pageIndex: 1,
          pageId: this.currentGloablPageId,
        };
        let textbookId = bookId || id;
        (pagePath == "/books" || pagePath == "/word") &&
        textbookId &&
        textbookId != 2
          ? (query.textbookId = textbookId)
          : null;
        this.$router.push({
          path: `/zyk${pagePath}`,
          query,
        });
      }
    },
    openTextbookEncyclopediaDialog() {
      this.$emit("openTextbookEncyclopediaDialog", null);
    },
  },
  mounted: function () {
    //定义小红点的过期时间
    let expireTime = "2024-10-13 00:00:00";
    let expireDate = new Date(expireTime);
    let now = new Date();
    this.showCircle = now < expireDate;
  },
};
</script>
<style lang="scss" scoped>
.zyk-header {
  background: transparent;
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  // border-bottom: 1px solid #e2e2e2;
  .zyk-header-left {
    display: flex;
    align-items: center;
    flex: 1;
    .logo {
      width: 48px;
      height: 48px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .page-info {
      margin-left: 16px;
      .page-title {
        display: flex;
        align-items: center;
        span {
          font-size: 16px;
          color: #1a1a1a;
          margin-right: 16px;
          font-weight: bold;
        }
      }
    }
    .tabs-header {
      // margin-top: 12px;
      .tab-item {
        position: relative;
        .new-tip {
          position: absolute;
          top: -4px;
          right: -22px;
          // padding: 0 4px;
          display: inline-block;
          height: 16px;
          line-height: 16px;
          font-weight: bold;

          // border-radius: 800px 800px 800px 0;
          color: #f14848;
          // color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 11px;
        }
      }
    }
  }
  .zyk-header-right {
    display: flex;
    align-items: center;
    .textbook-encyclopedia {
      position: relative;
      display: inline-flex;
      padding: var(----xkw-card-radious, 8px) 10px;
      align-items: center;
      gap: var(----xkw-small-radious, 4px);
      border-radius: var(----xkw-card-radious, 8px);
      background: #fff;
      box-shadow: 0px 3px 20px 0px rgba(68, 79, 87, 0.06);
      margin-right: 24px;
      cursor: pointer;

      .textbook-encyclopedia-word {
        color: var(-----xkw-font-primary-color, #1a1a1a);

        /* regular/--xkw-body-regular */
        font-family: "PingFang SC";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 157.143% */
      }
    }

    .search-input {
      width: 264px;
      height: 32px;
      line-height: 32px;
      border-radius: 6px;
      padding: 0 7px;
      border: 1px solid #d5d9e5;
      background: #fff;
      display: flex;
      align-items: center;
      i {
        font-size: 16px;
        color: #bababa;
        margin-right: 8px;
      }
      input {
        flex: 1;
        height: 100%;
      }
    }
    .download-btn {
      padding: 0 8px;
      margin-left: 30px;
      cursor: pointer;
      width: 92px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      height: 32px;
      border-radius: 4px;
      line-height: 32px;
      color: #7e7e7e;
      vertical-align: middle;
      i {
        vertical-align: middle;
      }
      &:hover {
        background: #f6f6f6;
      }
    }
    .line {
      width: 1px;
      height: 16px;
      background: #e2e2e2;
      margin: 0 26px 0 12px;
    }
    .open-tech-btn {
      color: #4494ff;
      font-size: 14px;
      display: flex;
      align-items: center;
      cursor: pointer;
      img {
        width: 16px;
        margin-left: 4px;
      }
    }
  }
}
</style>
